import styled, { css } from 'styled-components';
import theme from '@cld/theme-helper';

export interface PaperProps {
  rounded?: boolean;
  shadow?: boolean;
  padded?: boolean;
}

export const Paper = styled.div<PaperProps>`
  background: ${theme('palette.surface')};

  ${(props) =>
    props.shadow &&
    css`
      box-shadow: ${theme`shadow.sm`};
    `}

  ${(props) =>
    props.rounded &&
    css`
      border-radius: ${theme`spacing.xxs`};
    `};
  ${(props) =>
    props.padded &&
    css`
      padding: ${theme`spacing.md`};
    `};

  // we remove outline because we will focus list items
  outline: none;
`;
